import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const controlNavbar = () => {
            const heroSection = document.querySelector(".hero-section");
            if (!heroSection) return;

            const heroHeight = heroSection.offsetHeight;
            const currentScrollY = window.scrollY;

            if (
                currentScrollY > lastScrollY &&
                currentScrollY > heroHeight * 0.8
            ) {
                setIsVisible(false);
                setIsOpen(false);
            } else if (currentScrollY < lastScrollY) {
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", controlNavbar);
        return () => window.removeEventListener("scroll", controlNavbar);
    }, [lastScrollY]);

    // Login durumunu kontrol et
    useEffect(() => {
        const checkLoginStatus = () => {
            const token = localStorage.getItem('authToken');
            setIsLoggedIn(!!token);
            console.log("Token:", token);
        };

        checkLoginStatus();

        // Custom event listener ekle
        const handleLoginStatusChange = () => {
            checkLoginStatus();
        };

        window.addEventListener('loginStatusChanged', handleLoginStatusChange);
        window.addEventListener('storage', handleLoginStatusChange);
        
        return () => {
            window.removeEventListener('loginStatusChanged', handleLoginStatusChange);
            window.removeEventListener('storage', handleLoginStatusChange);
        };
    }, []);

    const handleLogout = () => {
        // localStorage'dan token ve user bilgilerini temizle
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        
        // Login durumunu güncelle
        setIsLoggedIn(false);
        
        // Ana sayfaya yönlendir
        navigate('/');
    };

    return (
        <div
            className={`fixed w-full z-[100] flex justify-center top-4 transition-all duration-500 ${
                isVisible
                    ? "translate-y-0 opacity-100"
                    : "-translate-y-full opacity-0"
            }`}
        >
            <nav className="bg-white/90 backdrop-blur-md shadow-lg rounded-full mx-4 w-full max-w-4xl">
                <div className="px-4 lg:px-6">
                    <div className="flex items-center justify-between h-14">
                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="md:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d={
                                        isOpen
                                            ? "M6 18L18 6M6 6l12 12"
                                            : "M4 6h16M4 12h16M4 18h16"
                                    }
                                />
                            </svg>
                        </button>

                        {/* Logo - Mobile'da ortada, Desktop'ta solda */}
                        <div className="md:relative md:left-0 md:transform-none absolute left-1/2 -translate-x-1/2 flex items-center">
                            <Link
                                to="/"
                                className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent transition-transform flex items-center gap-2"
                            >
                                Cyprus Yacht Club
                                <span className="text-lg">⛵</span>
                            </Link>
                        </div>

                        {/* Desktop menu */}
                        <div className="hidden md:flex items-center space-x-1 ml-8">
                            <Link
                                to="/"
                                className="px-3 py-1 text-base text-gray-600 hover:text-blue-600 nav-link"
                            >
                                Ana Sayfa
                            </Link>
                            <Link
                                to="/yachts"
                                className="px-3 py-1 text-base text-gray-600 hover:text-blue-600 nav-link"
                            >
                                Yatlar
                            </Link>
                            <Link
                                to="/about"
                                className="px-3 py-1 text-base text-gray-600 hover:text-blue-600 nav-link"
                            >
                                Hakkımızda
                            </Link>
                            <Link
                                to="/contact"
                                className="px-3 py-1 text-base text-gray-600 hover:text-blue-600 nav-link"
                            >
                                İletişim
                            </Link>
                        </div>

                        {/* Auth Buttons - Desktop */}
                        <div className="hidden md:flex items-center gap-2">
                            {isLoggedIn ? (
                                // Kullanıcı giriş yapmışsa - Kirala! sol, Hesap Ayarları, Çıkış Yap sağ
                                <>
                                    <Link
                                        to="/yachts"
                                        className="premium-button text-white text-sm px-4 py-1.5 rounded-full"
                                    >
                                        Kirala!
                                    </Link>
                                    <div className="flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1 hover:bg-gray-200 transition-colors ml-2">
                                        <Link
                                            to="/account-settings"
                                            className="text-gray-600 hover:text-blue-600 p-1 rounded-full hover:bg-gray-200 transition-colors"
                                        >
                                            <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                                />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                            </svg>
                                        </Link>
                                        <div className="w-px h-4 bg-gray-300"></div>
                                        <button
                                            onClick={handleLogout}
                                            className="text-sm text-gray-600 hover:text-red-600 px-2 py-1"
                                        >
                                            Çıkış Yap
                                        </button>
                                    </div>
                                </>
                            ) : (
                                // Kullanıcı giriş yapmamışsa - Giriş/Üye Ol sol, Kirala! sağ
                                <>
                            <div className="flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1 hover:bg-gray-200 transition-colors">
                                <Link
                                    to="/login"
                                            className="text-sm text-gray-600 hover:text-blue-600 px-3 py-1"
                                >
                                    Giriş
                                </Link>
                                <div className="w-px h-4 bg-gray-300"></div>
                                <Link
                                    to="/register"
                                            className="text-sm text-gray-600 hover:text-blue-600 px-3 py-1"
                                >
                                    Üye Ol
                                </Link>
                            </div>
                            <Link
                                to="/yachts"
                                className="premium-button text-white text-sm px-4 py-1.5 rounded-full ml-2"
                            >
                                Kirala!
                            </Link>
                                </>
                            )}
                        </div>

                        {/* Mobile placeholder for layout balance */}
                        <div className="w-8 md:hidden"></div>
                    </div>
                </div>

                {/* Mobile menu */}
                <div
                    className={`absolute top-full left-0 right-0 mt-2 mx-4 bg-white/90 backdrop-blur-md rounded-2xl shadow-lg transition-all duration-300 ease-in-out ${
                        isOpen
                            ? "opacity-100 visible translate-y-0"
                            : "opacity-0 invisible -translate-y-4"
                    }`}
                >
                    <div className="px-4 py-3 space-y-1">
                        <Link
                            to="/"
                            className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                        >
                            Ana Sayfa
                        </Link>
                        <Link
                            to="/yachts"
                            className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                        >
                            Yatlar
                        </Link>
                        <Link
                            to="/about"
                            className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                        >
                            Hakkımızda
                        </Link>
                        <Link
                            to="/contact"
                            className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                        >
                            İletişim
                        </Link>
                        <div className="border-t border-gray-200 my-2">
                            {isLoggedIn ? (
                                // Mobile Hesap Ayarları ve Çıkış Yap butonları
                                <>
                                    <Link
                                        to="/account-settings"
                                        className="flex items-center gap-3 px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                            />
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                            />
                                        </svg>
                                        Hesap Ayarları
                                    </Link>
                                    <button
                                        onClick={() => {
                                            handleLogout();
                                            setIsOpen(false);
                                        }}
                                        className="block w-full text-left px-3 py-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all duration-300"
                                    >
                                        Çıkış Yap
                                    </button>
                                </>
                            ) : (
                                // Mobile Giriş / Üye Ol butonları
                                <>
                            <Link
                                to="/login"
                                className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                            >
                                Giriş Yap
                            </Link>
                            <Link
                                to="/register"
                                className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-300"
                            >
                                Üye Ol
                            </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default Navbar;